import constate from 'constate';
import { useEffect, useState } from 'react';

import { QuoteVersionType } from 'quotes/enums';
import { IQuoteQuoteAssociationForm } from 'quotes/types';

const useCustomerQuoteParts = ({
  initialQuoteVersion,
}: {
  initialQuoteVersion: QuoteVersionType;
}) => {
  const [quoteQuoteAssociation, setQuoteQuoteAssociation] =
    useState<IQuoteQuoteAssociationForm | null>(null);
  const [isDraftVersionChanged, setIsDraftVersionChanged] = useState(
    QuoteVersionType.DRAFT === initialQuoteVersion
  );
  const [currentQuoteVersion, setCurrentQuoteVersion] =
    useState<QuoteVersionType>(initialQuoteVersion);

  useEffect(() => {
    setIsDraftVersionChanged(QuoteVersionType.DRAFT === initialQuoteVersion);
  }, [initialQuoteVersion]);

  const setDraftVersionChanged = (value = true) => setIsDraftVersionChanged(value);

  return {
    quoteQuoteAssociation,
    setQuoteQuoteAssociation,
    isDraftVersionChanged,
    setDraftVersionChanged,
    currentQuoteVersion,
    setCurrentQuoteVersion,
  };
};

export const [CustomerQuotePartsProvider, useCustomerQuotePartsContext] =
  constate(useCustomerQuoteParts);
